/**
 * Default number of StatSkeleton component displayed on loading state
 */
export const DEFAULT_STAT_SKELETON_DISPLAYED = 3;
